(function (win) {
    'use strict';

    var fp = (win.fp = win.fp || {});
    var layout = (fp.layout = fp.layout || {});

    var measure = function () {
        var root = document.documentElement;

        var set = function (name, value) {
            root.style.setProperty(name, value + 'px');
        };

        var isVisible = function (el) {
            return el && getComputedStyle(el).display !== 'none';
        };

        var setFromEl = function (name, el, requireVisible) {
            if (!el) { set(name, 0); return; }
            if (requireVisible && !isVisible(el)) { set(name, 0); return; }
            set(name, el.offsetHeight);
        };

        // Try each selector in order; use the height of the first visible match, else 0.
        var setFromFirstVisible = function (name, selectors) {
            for (var i = 0; i < selectors.length; i++) {
                var el = document.querySelector(selectors[i]);
                if (isVisible(el)) { set(name, el.offsetHeight); return; }
            }
            set(name, 0);
        };

        setFromEl('--header-height',           document.querySelector('header'),                           false);
        setFromEl('--logo-mobile-height',      document.getElementById('logo-mobile'),                     false);
        setFromEl('--utility-height',          document.getElementById('utility'),                         false);
        setFromEl('--special-message-height',  document.querySelector('#special-message.message-banner'),  true);
        setFromFirstVisible('--sticky-footer-height', ['#ao-sticky', '.footer-navigation-sticky', '#fixed-footer']);
        setFromEl('--footer-navigation-height', document.querySelector('.footer-navigation:not(.footer-navigation-sticky)'), true);
        setFromEl('--fp-cookie-consent-height', document.getElementById('fp-cookie-consent'),              true);
    };

    var debounce = function (fn, delay) {
        var t;
        return function () {
            var args = arguments, ctx = this;
            clearTimeout(t);
            t = setTimeout(function () { fn.apply(ctx, args); }, delay);
        };
    };

    layout.measure = measure;

    var debouncedMeasure = debounce(measure, 250);
    win.addEventListener('resize', debouncedMeasure);
    win.addEventListener('orientationchange', debouncedMeasure);
    win.addEventListener('load', function () { setTimeout(measure, 250); });
})(window);
